import { addDays, addMonths, addWeeks } from 'date-fns';
import { IconButton } from '../../../components/Button';
import chevronLeft from '../../../assets/chevron_left.svg';
import chevronRight from '../../../assets/chevron_right.svg';
import { CalendarGranularity } from '../types';
import { GranularitySwitcher } from './GranularitySwitcher';
import { MonthSelect } from './MonthSelect';

const TOOLBAR_CLASS = 'flex items-center';
const LEFT_CLUSTER_CLASS = 'flex items-center gap-4';
const RIGHT_CLUSTER_CLASS = 'ml-auto flex gap-2';
const PERIOD_LABEL_CLASS = 'text-medium font-medium capitalize text-dark-gray';
const NAV_BUTTON_CLASS = 'rounded-md';

function shiftAnchor(anchor: Date, granularity: CalendarGranularity, direction: 1 | -1): Date {
    if (granularity === CalendarGranularity.Month) return addMonths(anchor, direction);
    if (granularity === CalendarGranularity.Week) return addWeeks(anchor, direction);
    return addDays(anchor, direction);
}

type CalendarToolbarProps = Readonly<{
    anchorDate: Date;
    onAnchorChange: (next: Date) => void;
    granularity: CalendarGranularity;
    onGranularityChange: (next: CalendarGranularity) => void;
    periodLabel: string;
}>;

export function CalendarToolbar({
    anchorDate,
    onAnchorChange,
    granularity,
    onGranularityChange,
    periodLabel,
}: CalendarToolbarProps) {
    const goPrevious = () => onAnchorChange(shiftAnchor(anchorDate, granularity, -1));
    const goNext = () => onAnchorChange(shiftAnchor(anchorDate, granularity, 1));

    return (
        <div className={TOOLBAR_CLASS}>
            <div className={LEFT_CLUSTER_CLASS}>
                <GranularitySwitcher
                    granularity={granularity}
                    onGranularityChange={onGranularityChange}
                />

                {granularity === CalendarGranularity.Month ? (
                    <MonthSelect anchorDate={anchorDate} onAnchorChange={onAnchorChange} />
                ) : (
                    <span className={PERIOD_LABEL_CLASS}>{periodLabel}</span>
                )}
            </div>

            <div className={RIGHT_CLUSTER_CLASS}>
                <IconButton
                    icon={chevronLeft}
                    type="button"
                    isPrimary={false}
                    className={NAV_BUTTON_CLASS}
                    onClick={goPrevious}
                    aria-label="Période précédente"
                />
                <IconButton
                    icon={chevronRight}
                    type="button"
                    isPrimary={false}
                    className={NAV_BUTTON_CLASS}
                    onClick={goNext}
                    aria-label="Période suivante"
                />
            </div>
        </div>
    );
}
